module.exports = __webpack_public_path__ + "img/close.92689ccd.svg";